import { useContext } from 'react';
import GlobalConfigContext from 'helpers/GlobalConfigContext';

export default function useGlobalConfig() {
  const globalConfig = useContext(GlobalConfigContext);

  if (!globalConfig) {
    throw new Error('[useGlobalConfig] expected user config to be truthy');
  }

  return globalConfig;
}
